import React, { useState, useEffect } from "react";
import { Grid, TextField, Button, Select, MenuItem, FormControl, Tooltip, InputLabel, Card, CardContent, Typography, Container, FormHelperText, Autocomplete, Box, Divider, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { authKey, GET_WEEK_START_END_DATE, GET_APPROVED_STAKEHOLDERS, GET_MAPPED_PLANNING_NUMBER_LIST, GET_MAPPED_GROWER_PO_FOR_HIT_MANUAL_PO, CREATE_HIT_MANUAL_SCHEDULE, FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN } from '../../common/URLs';
import { toast } from 'react-toastify';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";

import DeleteIcon from '@mui/icons-material/Delete';
import { PROD } from "../../common/constants";
import { DataGrid } from "@mui/x-data-grid";
import Moment from 'moment';
import moment from 'moment';
import ClearIcon from '@mui/icons-material/Clear';
import { QuickSearchToolbar } from "../../payment/common/commonFunctions";
import { CustomButton } from "../../common/custom-button/customButton";
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { PlantConsumptionPopover } from "./plantCBConsumption/plantConsumptionPopover";
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { handleNumberFieldFocus } from "../../common/commonFunction";
import { SaveIcon, SubmitIcon } from "../../common/icons";
import apiClient from "../../axios";

const ManualScheduleCreation = () => {

    const [urnList, setUrnList] = useState([]);
    const [isApiCalled, setIsApiCalled] = useState(false);
    const [mappedPoList, setMappedPoList] = useState();
    const [planningNumberList, setPlanningNumberList] = useState();
    const [planningNumber, setPlanningNumber] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [getStartEndDate, setGetStartEndDate] = useState([]);
    const [getHolidayList, setGetHolidayList] = useState([]);
    const [distinctUrnValues, setDistinctUrnValues] = useState([]);
    const [stakeholderUrn, setStakeholderUrn] = useState('');
    const [stakeholderType, setStakeholderType] = useState('');
    const [destinationUrnList, setDestinationUrnList] = useState();

    const weekDayList = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]

    const [selectedPoData, setSelectedPoData] = React.useState([]);
    const [submitArr, setSubmitArr] = useState([])

    const [open, setOpen] = React.useState(false);
    const [rowData, setRowData] = useState();

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [details, setDetails] = useState({
        "weekNumber": "",
        "expectedDeliveryDays": "",
        "scheduleQuantity1": "",
        "scheduleQuantity2": "",
        "scheduleQuantity3": "",
        "scheduleQuantity4": "",
        "scheduleQuantity5": "",
        "scheduleQuantity6": "",
        "scheduleQuantity7": ""
    });

    const [errorMessage, setErrorMessage] = useState({
        "planningNumberError": "",
        "weekNumberError": "",
        "expectedDeliveryDaysError": "",
        "scheduleQuantity1Error": "",
        "scheduleQuantity2Error": "",
        "scheduleQuantity3Error": "",
        "scheduleQuantity4Error": "",
        "scheduleQuantity5Error": "",
        "scheduleQuantity6Error": "",
        "scheduleQuantity7Error": "",
        "noSelectedPoError": "",
    });


    const get_Mapped_Grower_PoList = (Year, Month, planningNo) => {
        loaderService.showLoader();
        apiClient.post(GET_MAPPED_GROWER_PO_FOR_HIT_MANUAL_PO,
            {
                "financialYear": Year,
                "planningMonth": Month,
                "planningNumber": planningNo,
                "stakeholderUrn": searchTerm
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setMappedPoList(response.data.poDetailsList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getPlanningNumberList = (selectedUrn, destinationType, destinationUrn) => {
        loaderService.showLoader();
        apiClient.post(GET_MAPPED_PLANNING_NUMBER_LIST,
            {
                "stakeHolderUrn": selectedUrn,
                "stakeHolderType": "HIT",
                "mappedStakeHolderType": "Grower",
                "destinationStakeHolderType": destinationType ? destinationType : stakeholderType,
                "destinationStakeHolderUrn": destinationUrn ? destinationUrn : stakeholderUrn
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setPlanningNumberList(response.data.planningNumberList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const onPlanningNumberChange = (e) => {
        setPlanningNumber(e.target.value);
        setErrorMessage({ ...errorMessage, planningNumberError: "" });
        let selectedObj = planningNumberList?.find(item => item.planningNumber === e.target.value);
        if (selectedObj) {
            get_Mapped_Grower_PoList(selectedObj?.financialYear, selectedObj?.month, selectedObj?.planningNumber)
        }
    }

    useEffect(() => {
        getUrnList();
    }, []);

    const getUrnList = () => {
        loaderService.showLoader();
        apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                "type": "HIT"
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setUrnList(response.data.stakeHolders);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const urns = urnList?.map(item => item.urn);

    const handleSearch = (query) => {
        const results = urns.filter(urn =>
            urn && query && urn.toLowerCase().includes(query.toLowerCase())
        );
        setSearchResults(results);
    };

    const handleClear = () => {
        setSearchTerm('');
        setSearchResults([]);
    };

    const handleCheckboxChange = (selectedRowIds) => {
        setSelectedPoData(selectedRowIds)
        setErrorMessage({ ...errorMessage, noSelectedPoError: "" })
    };


    const columns = [
        { field: 'poNumber', headerName: 'PO', flex: 1 },
        { field: 'poQuantity', headerName: 'Total Quantity', flex: 1 },
        // { field: 'poShortCloseQuantity', headerName: 'Short Close Quantity', flex: 1 },
        { field: 'poBalanceQuantity', headerName: 'Balance Quantity (MT)', flex: 1 },
        // { field: 'destinationStakeholderUrn', headerName: 'Destination Stakeholder', flex: 1 },
        {
            field: 'action',
            headerName: 'Action',
            type: 'action',
            flex: 1,
            renderCell: (params) => (
                <Tooltip title="Edit/Add">
                    <IconButton variant="contained"
                        onClick={() => handleClickOpen(params.row)}
                    >{submitArr.find((item) => item.poNumber === params.row.poNumber) ? "Edit" : "Add"}</IconButton>
                </Tooltip>
            )
        },
    ];

    const handleClickOpen = (row) => {
        setOpen(true);
        setRowData(row);
        const foundObj = submitArr.find((item) => item.poNumber === row.poNumber)
        if (foundObj) {
            setDetails({
                "weekNumber": foundObj.weekNumber,
                "expectedDeliveryDays": foundObj.expectedDeliveryDays,
                "scheduleQuantity1": foundObj.scheduleQuantityList[0] && foundObj.scheduleQuantityList[0].scheduleRbCbQuantity,
                "scheduleQuantity2": foundObj.scheduleQuantityList[1] && foundObj.scheduleQuantityList[1].scheduleRbCbQuantity,
                "scheduleQuantity3": foundObj.scheduleQuantityList[2] && foundObj.scheduleQuantityList[2].scheduleRbCbQuantity,
                "scheduleQuantity4": foundObj.scheduleQuantityList[3] && foundObj.scheduleQuantityList[3].scheduleRbCbQuantity,
                "scheduleQuantity5": foundObj.scheduleQuantityList[4] && foundObj.scheduleQuantityList[4].scheduleRbCbQuantity,
                "scheduleQuantity6": foundObj.scheduleQuantityList[5] && foundObj.scheduleQuantityList[5].scheduleRbCbQuantity,
                "scheduleQuantity7": foundObj.scheduleQuantityList[6] && foundObj.scheduleQuantityList[6].scheduleRbCbQuantity,
            })
        }
    };

    const handleClose = (newValue) => {
        setOpen(false);
    };

    const dialogSection = () => {
        return (
            <Dialog onClose={handleClose} open={open} maxWidth='md' fullWidth={true}>
                {/* <DialogTitle> HIT Schedule </DialogTitle> */}
                <DialogContent>
                    <Container>
                        <Typography variant="h5" gutterBottom>
                            HIT Schedule
                        </Typography>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <>
                                        <Grid item xs={12} lg={4}>
                                            <FormControl fullWidth size="small" required error={errorMessage.weekNumberError}>
                                                <InputLabel>Week Number</InputLabel>
                                                <Select label="Week Number" name="weekNumber" value={details?.weekNumber} onChange={(e) => handleChange(e)}>
                                                    <MenuItem value="select" selected>Week Number</MenuItem>
                                                    <MenuItem value="1">1</MenuItem>
                                                    <MenuItem value="2">2</MenuItem>
                                                    <MenuItem value="3">3</MenuItem>
                                                    <MenuItem value="4">4</MenuItem>
                                                    <MenuItem value="5">5</MenuItem>
                                                    <MenuItem value="6">6</MenuItem>
                                                </Select>
                                                <FormHelperText sx={{ color: 'red' }}>{errorMessage.weekNumberError}</FormHelperText>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth size="small"
                                                required
                                                error={errorMessage.expectedDeliveryDaysError}
                                                helperText={errorMessage.expectedDeliveryDaysError}
                                                label="Expected Delivery Days"
                                                type="number"
                                                onFocus={handleNumberFieldFocus}
                                                name="expectedDeliveryDays"
                                                value={details.expectedDeliveryDays}
                                                onChange={(e) => handleChange(e)}
                                            />
                                        </Grid>
                                        {getStartEndDate?.weekStartDate &&
                                            <>
                                                <Grid item xs={12} lg={12}>
                                                    <Typography variant="h6" gutterBottom>
                                                        Schedule Quantity
                                                    </Typography>
                                                </Grid>
                                                {process(date1) <= process(enddateFormat) && !(holidate.includes(date1)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity1Error}
                                                            helperText={errorMessage.scheduleQuantity1Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity1"
                                                            value={details.scheduleQuantity1}
                                                            label={weekDayList[new Date(date1).getDay()] + ' ' + (date1 && Moment(date1).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />
                                                    </Grid>
                                                    : null
                                                }
                                                {process(date2) <= process(enddateFormat) && !(holidate.includes(date2)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity2Error}
                                                            helperText={errorMessage.scheduleQuantity2Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity2"
                                                            value={details.scheduleQuantity2}
                                                            label={weekDayList[new Date(date2).getDay()] + ' ' + (date2 && Moment(date2).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date3) <= process(enddateFormat) && !(holidate.includes(date3)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity3Error}
                                                            helperText={errorMessage.scheduleQuantity3Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity3"
                                                            value={details.scheduleQuantity3}
                                                            label={weekDayList[new Date(date3).getDay()] + ' ' + (date3 && Moment(date3).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date4) <= process(enddateFormat) && !(holidate.includes(date4)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity4Error}
                                                            helperText={errorMessage.scheduleQuantity4Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity4"
                                                            value={details.scheduleQuantity4}
                                                            label={weekDayList[new Date(date4).getDay()] + ' ' + (date4 && Moment(date4).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date5) <= process(enddateFormat) && !(holidate.includes(date5)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity5Error}
                                                            helperText={errorMessage.scheduleQuantity5Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity5"
                                                            value={details.scheduleQuantity5}
                                                            label={weekDayList[new Date(date5).getDay()] + ' ' + (date5 && Moment(date5).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}
                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date6) <= process(enddateFormat) && !(holidate.includes(date6)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity6Error}
                                                            helperText={errorMessage.scheduleQuantity6Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity6"
                                                            value={details.scheduleQuantity6}
                                                            label={weekDayList[new Date(date6).getDay()] + ' ' + (date6 && Moment(date6).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                                                        />

                                                    </Grid>
                                                    : null
                                                }
                                                {process(date7) <= process(enddateFormat) && !(holidate.includes(date7)) ?
                                                    <Grid item xs={12} lg={4}>
                                                        <TextField fullWidth required size="small"
                                                            error={errorMessage.scheduleQuantity7Error}
                                                            helperText={errorMessage.scheduleQuantity7Error}
                                                            type="number"
                                                            onFocus={handleNumberFieldFocus}
                                                            name="scheduleQuantity7"
                                                            value={details.scheduleQuantity7}
                                                            label={weekDayList[new Date(date7).getDay()] + ' ' + (date7 && Moment(date7).format('DD/MM/YYYY'))}
                                                            onChange={(e) => handleChange(e)}
                                                            day1Consumption={true}
                                                            onKeyDown={(evt) => (evt.key === '_' || evt.key === '-' || evt.key === 'e' || evt.key === 'E' || evt.key === ',' || evt.key === '+' || evt.key === '!' || evt.key === '@' || evt.key === '#' || evt.key === '$' || evt.key === '%' || evt.key === '^' || evt.key === '&' || evt.key === '*' || evt.key === '(' || evt.key === ')') && evt.preventDefault()}

                                                        />

                                                    </Grid>
                                                    : null
                                                }

                                            </>
                                        }

                                    </>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Container>

                </DialogContent>
                <DialogActions>
                    <CustomButton
                        style={{ marginTop: 5, float: 'right', marginBottom: 5 }}
                        onClick={() => onSave()}
                        title="Save"
                        startIcon={<SaveIcon />}>Save
                    </CustomButton>
                </DialogActions>
            </Dialog>

        )
    }

    const onSave = () => {

        if (!details?.weekNumber) {
            setErrorMessage({ ...errorMessage, weekNumberError: "Please Select Week Number" })
        }
        else if (!details?.expectedDeliveryDays) {
            setErrorMessage({ ...errorMessage, expectedDeliveryDaysError: "Please Enter Expected Delivery days" })
        }
        else if (process(date1) <= process(enddateFormat) && !details?.scheduleQuantity1 && !(holidate.includes(date1))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity1Error: "Please Enter Quantity" })
        }
        else if (process(date2) <= process(enddateFormat) && !details?.scheduleQuantity2 && !(holidate.includes(date2))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity2Error: "Please Enter Quantity" })
        }
        else if (process(date3) <= process(enddateFormat) && !details?.scheduleQuantity3 && !(holidate.includes(date3))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity3Error: "Please Enter Quantity" })
        }
        else if (process(date4) <= process(enddateFormat) && !details?.scheduleQuantity4 && !(holidate.includes(date4))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity4Error: "Please Enter Quantity" })
        }
        else if (process(date5) <= process(enddateFormat) && !details?.scheduleQuantity5 && !(holidate.includes(date5))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity5Error: "Please Enter Quantity" })
        }
        else if (process(date6) <= process(enddateFormat) && !details?.scheduleQuantity6 && !(holidate.includes(date6))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity6Error: "Please Enter Quantity" })
        }
        else if (process(date7) <= process(enddateFormat) && !details?.scheduleQuantity7 && !(holidate.includes(date7))) {
            setErrorMessage({ ...errorMessage, scheduleQuantity7Error: "Please Enter Quantity" })
        }
        else {
            handleModalSaveBtn();
        }
    }

    const handleModalSaveBtn = () => {
        let tempArr = [];
        if (details?.scheduleQuantity1) {
            tempArr.push({
                "schedulePickupDate": date1,
                "scheduleRbCbQuantity": details.scheduleQuantity1
            })
        }
        if (details?.scheduleQuantity2) {
            tempArr.push({
                "schedulePickupDate": date2,
                "scheduleRbCbQuantity": details.scheduleQuantity2

            })
        }

        if (details?.scheduleQuantity3) {
            tempArr.push({
                "schedulePickupDate": date3,
                "scheduleRbCbQuantity": details.scheduleQuantity3

            })
        }

        if (details?.scheduleQuantity4) {
            tempArr.push({
                "schedulePickupDate": date4,
                "scheduleRbCbQuantity": details.scheduleQuantity4

            })
        }

        if (details?.scheduleQuantity5) {
            tempArr.push({
                "schedulePickupDate": date5,
                "scheduleRbCbQuantity": details.scheduleQuantity5
            })
        }

        if (details?.scheduleQuantity6) {
            tempArr.push({
                "schedulePickupDate": date6,
                "scheduleRbCbQuantity": details.scheduleQuantity6
            })
        }

        if (details?.scheduleQuantity7) {
            tempArr.push({
                "schedulePickupDate": date7,
                "scheduleRbCbQuantity": details.scheduleQuantity7

            })
        }
        if (submitArr.find((item) => item.poNumber === rowData.poNumber)) {
            submitArr.map((item) => {
                if (item.poNumber === rowData.poNumber) {
                    item.weekNumber = details.weekNumber
                    item.expectedDeliveryDays = details.expectedDeliveryDays
                    item.scheduleQuantityList = tempArr
                }
                return item
            }
            )
        }
        else {
            submitArr.push(
                {
                    "financialYear": rowData.financialYear,
                    "month": rowData.month,
                    "planningNumber": rowData.planningNumber,
                    "weekNumber": details.weekNumber,
                    "expectedDeliveryDays": details.expectedDeliveryDays,
                    "firstPartyUrn": rowData.poStakeholderUrn,
                    "firstPartyType": rowData.poStakeholderType,
                    "secondPartyUrn": stakeholderUrn,
                    "secondPartyType": stakeholderType,
                    "poNumber": rowData.poNumber,
                    "isManualyCreated": true,
                    "inventoryType": rowData.poMaterialType,
                    "activityType": "",
                    "startDate": getStartEndDate?.weekStartDate,
                    "endDate": getStartEndDate?.weekEndDate,
                    "scheduleQuantityList": tempArr
                }
            )
        }
        handleClose();
        setDetails(
            {
                "weekNumber": "",
                "expectedDeliveryDays": "",
                "scheduleQuantity1": "",
                "scheduleQuantity2": "",
                "scheduleQuantity3": "",
                "scheduleQuantity4": "",
                "scheduleQuantity5": "",
                "scheduleQuantity6": "",
                "scheduleQuantity7": ""
            }
        );
    }

    const onCreateHitManualSchedule = () => {
        loaderService.showLoader();
        // console.log("selectedPoData?.findIndex(item.poNumber)", selectedPoData?.indexOf("ghfgfg"))
        apiClient.post(CREATE_HIT_MANUAL_SCHEDULE,
            {
                "hitUrn": searchTerm,
                "manualScheduleCreationList": submitArr?.filter((item) => selectedPoData?.indexOf(item.poNumber) !== -1 ? true : false)
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (response.data) {
                    if (response.data.isSuccess == true) {
                        toast.success(response.data.message);
                        setPlanningNumber("");
                        setMappedPoList([]);
                        setRowData();
                        setSelectedPoData([]);
                        setSubmitArr([]);
                        setStakeholderType("");
                        setStakeholderUrn("");
                    }
                    else toast.error(response.data.message);
                }
                else toast.error("Something went wrong, Please try again later!");
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        if (rowData && details?.weekNumber)
            getromandToDate();
    }, [rowData, details?.weekNumber]);


    const getromandToDate = () => {
        if (rowData && details?.weekNumber) {
            loaderService.showLoader()
            let fiscalYear = rowData?.financialYear?.split('-')
            let monthNameToNumber = {
                Jan: 1,
                Feb: 2,
                Mar: 3,
                Apr: 4,
                May: 5,
                Jun: 6,
                Jul: 7,
                Aug: 8,
                Sep: 9,
                Oct: 10,
                Nov: 11,
                Dec: 12
            };
            let monthName = rowData?.month; // Replace this with the actual value from the API
            let monthNumber = monthNameToNumber[monthName];
            apiClient
                .post(
                    GET_WEEK_START_END_DATE,
                    {
                        "year": monthNumber === 1 || monthNumber === 2 || monthNumber === 3 ? fiscalYear[1] : fiscalYear[0],
                        "month": monthNumber,
                        "weekNumber": details?.weekNumber,
                        "financialYear": rowData?.financialYear
                    },
                    {
                        headers:
                        {
                            Authorization: "Bearer " + getLocalStorageItem('id_token'),
                        },
                    },
                    null
                )
                .then((response) => {
                    setGetStartEndDate(response.data.weekDaysDetails);
                    response.data.weekDaysDetails?.weekStartDate === null && onClickWeekNo()
                    setGetHolidayList(response.data.plantHoldiday?.date);
                    loaderService.hideLoader();
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader();
                    toast.error(error.message);
                });
        }
    };

    const handleChange = (e) => {
        const limit = 10
        setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) });
        if (e.target.name === "weekNumber") {
            setDetails({
                ...details,
                [e.target.name]: e.target.value.slice(0, limit),
                "expectedDeliveryDays": "",
                scheduleQuantity1: "",
                scheduleQuantity2: "",
                scheduleQuantity3: "",
                scheduleQuantity4: "",
                scheduleQuantity5: "",
                scheduleQuantity6: "",
                scheduleQuantity7: "",
            })
            setErrorMessage({ ...errorMessage, weekNumberError: "" });
        }
        if (e.target.name === "expectedDeliveryDays") {
            setErrorMessage({ ...errorMessage, expectedDeliveryDaysError: "" });
        }

        if (e.target.name === "scheduleQuantity1") {
            setErrorMessage({ ...errorMessage, scheduleQuantity1Error: "" });
        }
        if (e.target.name === "scheduleQuantity2") {
            setErrorMessage({ ...errorMessage, scheduleQuantity2Error: "" });
        }
        if (e.target.name === "scheduleQuantity3") {
            setErrorMessage({ ...errorMessage, scheduleQuantity3Error: "" });
        }
        if (e.target.name === "scheduleQuantity4") {
            setErrorMessage({ ...errorMessage, scheduleQuantity4Error: "" });
        }
        if (e.target.name === "scheduleQuantity5") {
            setErrorMessage({ ...errorMessage, scheduleQuantity5Error: "" });
        }
        if (e.target.name === "scheduleQuantity6") {
            setErrorMessage({ ...errorMessage, scheduleQuantity6Error: "" });
        }
        if (e.target.name === "scheduleQuantity7") {
            setErrorMessage({ ...errorMessage, scheduleQuantity7Error: "" });
        }
    };

    const date1 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(0, 'days').format('YYYY-MM-DD')
    const date2 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(1, 'days').format('YYYY-MM-DD')
    const date3 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(2, 'days').format('YYYY-MM-DD')
    const date4 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(3, 'days').format('YYYY-MM-DD')
    const date5 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(4, 'days').format('YYYY-MM-DD')
    const date6 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(5, 'days').format('YYYY-MM-DD')
    const date7 = getStartEndDate?.weekStartDate && Moment(getStartEndDate?.weekStartDate).add(6, 'days').format('YYYY-MM-DD')
    const enddateFormat = getStartEndDate?.weekEndDate && Moment(getStartEndDate?.weekEndDate).format('YYYY-MM-DD')

    const holidate = getHolidayList?.map((date) => {
        return moment(moment(date)).format('YYYY-MM-DD');
    });

    const process = (date) => {
        if (date) {
            var parts = date?.split("-");
            return new Date(parts[0], parts[1] - 1, parts[2]);
        }
    }

    const onClickWeekNo = (onClose) => {
        handleLogModalOpen(onClose);
    }

    // const onConfirmSubmit = () => {
    //     handleConfirmClose();
    //     onCreateHitManualSchedule();
    // }

    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onCreateHitManualSchedule();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    };

    const onSubmitButtonClick = () => {
        handleConfirmOpen();
    }

    const onSubmit = () => {
        if (!searchTerm) {
            setErrorMessage({ ...errorMessage, searchUrnError: "Please Select URN" })
        }
        else if (!planningNumber) {
            setErrorMessage({ ...errorMessage, planningNumberError: "Please Select Planning Number" })
        }
        else if (!stakeholderType) {
            setErrorMessage({ ...errorMessage, stakeholderTypeError: "Please Select Destination Type" })
        }
        else if (!stakeholderUrn) {
            setErrorMessage({ ...errorMessage, stakeholderUrnError: "Please Select Destination URN" })
        }
        else if (selectedPoData?.length === 0) {
            toast.error("Please Select atleast one PO")
        }
        else if (!selectedPoData.every(poNumber => submitArr.some(obj => obj.poNumber === poNumber))) {
            toast.error("Please add required details for all the selected POs")
        }
        else {
            onSubmitButtonClick();
        }
    }

    // const [value, setValue] = useState(0);

    // const handleIncrease = () => {
    //     setValue((prevValue) => prevValue + 1);
    // };

    // const handleDecrease = () => {
    //     setValue((prevValue) => Math.max(0, prevValue - 1)); // Ensure the value doesn't go below zero
    // };

    useEffect(() => {
        if (stakeholderType) {
            onStakeholderTypeChange();
        }
    }, [stakeholderType]);


    const onStakeholderTypeChange = () => {
        loaderService.showLoader();
        apiClient.post(FETCH_MAPPED_STAKEHOLDER_BY_TYPE_URN,
            {
                "stakeholderType": "HIT",
                "stakeholderUrn": searchTerm
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                if (stakeholderType === "LLE") {
                    setDestinationUrnList(response.data.llleMappedPojo);
                }
                if (stakeholderType === "Interim Storage Operator") {
                    setDestinationUrnList(response.data.isMappedPojo)
                }
                if (stakeholderType === "Plant") {
                    setDestinationUrnList(response.data.plantMappedPojo);
                }

                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    useEffect(() => {
        const uniqueValues = Array.from(new Set(destinationUrnList?.map(item => item.stakeholderUrn)));
        const distinctObjects = uniqueValues?.map(value => { return destinationUrnList.find(item => item.stakeholderUrn === value); });
        setDistinctUrnValues(distinctObjects);
    }, [destinationUrnList]);

    const onTypeChange = (e) => {
        setStakeholderType(e.target.value);
        getPlanningNumberList(searchTerm, e.target.value, stakeholderUrn);
        setErrorMessage({ ...errorMessage, stakeholderTypeError: "" });
        setStakeholderUrn("");
        setDestinationUrnList([]);
    }

    const onUrnChange = (e) => {
        setStakeholderUrn(e.target.value);
        getPlanningNumberList(searchTerm, stakeholderType, e.target.value)
        setErrorMessage({ ...errorMessage, stakeholderUrnError: "" });
    }



    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT20</p>}
                <Typography variant="h5" gutterBottom>
                    HIT Schedule Creation
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} lg={3}>
                                        <Autocomplete
                                            value={searchTerm}
                                            onChange={(_, newValue) => {
                                                setSearchTerm(newValue);
                                                handleSearch(newValue);
                                                // getPlanningNumberList(newValue);
                                                getPlanningNumberList(newValue, stakeholderType, stakeholderUrn)
                                                setErrorMessage({ ...errorMessage, searchUrnError: "" });
                                                setPlanningNumber("");
                                                setMappedPoList([]);
                                                setStakeholderType("");
                                                setStakeholderUrn("");
                                            }}
                                            options={urns || []}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Search URN" variant="outlined" fullWidth size="small"
                                                    required error={errorMessage.searchUrnError} helperText={errorMessage.searchUrnError}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        endAdornment: (
                                                            <>
                                                                {searchTerm && (
                                                                    <ClearIcon
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={handleClear}
                                                                    />
                                                                )}
                                                            </>
                                                        ),
                                                    }}
                                                />
                                            )}
                                        />

                                    </Grid>

                                    <Grid item xs={12} lg={3}>
                                        <FormControl fullWidth size="small" required={errorMessage.stakeholderTypeError}>
                                            <InputLabel>Destination Stakeholder Type</InputLabel>
                                            <Select label="Desination Stakeholder Type" name="secondPartyType" value={stakeholderType || ''} onChange={(e) => onTypeChange(e)}>
                                                <MenuItem value="LLE">LLE</MenuItem>
                                                <MenuItem value="InterimStorageOperator">ISO</MenuItem>
                                                <MenuItem value="Plant">Plant</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.stakeholderTypeError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl fullWidth size="small" required error={errorMessage.stakeholderUrnError}>
                                            <InputLabel>Destination Stakeholder URN</InputLabel>
                                            <Select label="Destination Stakeholder URN" value={stakeholderUrn || ''} name="secondPartyUrn" onChange={(e) => onUrnChange(e)}>
                                                {distinctUrnValues &&
                                                    distinctUrnValues?.map((items) => (
                                                        <MenuItem value={items.stakeholderUrn}>{items.stakeholderUrn}</MenuItem>

                                                    ))}
                                                {/* {stakeholderType === "Plant" &&
                                                    <MenuItem value="ABEPL">ABEPL</MenuItem>} */}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.stakeholderUrnError}</FormHelperText>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} lg={3}>
                                        <FormControl fullWidth size="small" required error={errorMessage.planningNumberError}>
                                            <InputLabel>Planning Number</InputLabel>
                                            <Select label="Planning Number" name="planningNumber" value={planningNumber || ''} onChange={(e) => onPlanningNumberChange(e)}>
                                                <MenuItem><em>Planning Number</em></MenuItem>
                                                {planningNumberList &&
                                                    planningNumberList?.map((items) => (
                                                        <MenuItem value={items.planningNumber}>{items.planningNumber}</MenuItem>

                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.planningNumberError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    {/* <Grid item xs={12} lg={4}>
                                        <TextField fullWidth
                                            size="small"
                                            label="Expected Delivery Days"
                                            type="number"
                                            value={value}
                                            onChange={(e) => setValue(Math.max(0, parseInt(e.target.value, 10)))} // Ensure input value is not negative
                                            InputProps={{
                                                endAdornment: (
                                                    <>
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={handleIncrease} edge="end">
                                                                <ArrowUpwardIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={handleDecrease} edge="end">
                                                                <ArrowDownwardIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    </>
                                                ),
                                            }}
                                        />
                                    </Grid> */}
                                    {
                                        mappedPoList &&
                                        <Grid item xs={12} lg={12}>
                                            <Typography sx={{ color: "red", mb: 1 }}>{errorMessage.noSelectedPoError}</Typography>
                                            <Box style={{ height: 400, width: '100%' }}>
                                                <DataGrid
                                                    rows={mappedPoList}
                                                    columns={columns}
                                                    pageSize={5}
                                                    checkboxSelection
                                                    components={{ Toolbar: QuickSearchToolbar }}
                                                    onSelectionModelChange={handleCheckboxChange}
                                                    disableSelectionOnClick
                                                    getRowId={(row) => row.poNumber}

                                                />
                                            </Box>
                                            {dialogSection()}
                                        </Grid>
                                    }

                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button endIcon={<SubmitIcon />} sx={{ minWidth: 100 }} variant="contained" type='submit' onClick={(e) => onSubmit(e)}>Submit</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSubmit} onClose={handleConfirmClose} action="Submit" />
            <Dialog maxWidth='xs' fullWidth open={logModalOpen}>
                <DialogContent>
                    <PlantConsumptionPopover handleLogModalClose={handleLogModalClose} />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default ManualScheduleCreation;